export default __webpack_public_path__ + "static/media/coinimg.b03cc7ee.png";